import EstimatorAvatar from './EstimatorAvatar'
export type { EstimatorAvatarProps } from './EstimatorAvatar'
export default EstimatorAvatar
